<div class="absolute left-0 top-0 z-30 h-full w-full overflow-hidden pt-14">
  <div
    class="flex h-full w-full justify-center bg-bo-black/20 px-20 py-5 backdrop-blur-lg"
  >
    <div
      class="flex h-full flex-col rounded-xl bg-bo-white shadow-lg"
      [ngClass]="guidance().orientation === 'landscape' ? 'w-4/5' : 'w-1/3'"
      (click)="isVisible.set(false)"
    >
      <div class="bo-header flex items-center justify-between rounded-t-lg p-3">
        <div>{{ guidance().name }}</div>
        <svg-icon
          src="fa-icons/xmark.svg"
          class="cursor-pointer fill-bo-shady-dark"
          [svgStyle]="{ 'height.px': 32 }"
          (click)="isVisible.set(false)"
        />
      </div>
      <div class="h-full w-full overflow-hidden rounded-b-xl">
        <video
          [src]="guidance().video"
          class="h-full w-full object-cover"
          autoplay
          loop
        ></video>
      </div>
    </div>
  </div>
</div>
